import { fromJS } from 'immutable';
import { BLOCK_GET_LOADED } from '../../../actions/Entity/Block';
var initialState = fromJS({});
export default function block() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case BLOCK_GET_LOADED:
      {
        return state.set(action.block_id, fromJS(action.data));
      }
    default:
      return state;
  }
}